module.exports = __webpack_public_path__ + "static/media/middle.d3336a72.jpg";